import { render, staticRenderFns } from "./TicketPreviewFooter.vue?vue&type=template&id=308f11f8&scoped=true"
import script from "./TicketPreviewFooter.vue?vue&type=script&lang=js"
export * from "./TicketPreviewFooter.vue?vue&type=script&lang=js"
import style0 from "./TicketPreviewFooter.vue?vue&type=style&index=0&id=308f11f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308f11f8",
  null
  
)

export default component.exports